export default __webpack_public_path__ + "static/media/Jordan_Curnew.60f92d8e.jpg";